import { Chip, Box, alpha } from "@mui/material";
import { Check, ContentCopy } from "@mui/icons-material";
import {
  CopyableChipProps,
  getBackgroundColor,
  getLabelText,
} from "./utils/copyable.utils";

export const CopyableChipView = ({
  initialLabel,
  size = "small",
  state,
  theme,
  t,
}: CopyableChipProps) => {
  const { isCopied, isHovered, setIsHovered, handleCopy } = state;

  // 🔑 texts
  const copiedText = t("common.copied");
  const copyText = t("buttons.copy");

  const labelText = getLabelText(isCopied, isHovered, initialLabel, t);
  const backgroundColor = getBackgroundColor(isCopied, isHovered, theme);

  // 🔑 WIDTH FIX (flicker çözümü)
  const maxLength = Math.max(
    initialLabel.length,
    copiedText.length,
    copyText.length,
  );

  const minWidth = `${maxLength}ch`;

  const color = isCopied
    ? theme.palette.success.main
    : theme.palette.primary.main;

  return (
    <Chip
      clickable
      size={size}
      onClick={handleCopy}
      onMouseEnter={() => !isCopied && setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      icon={
        isCopied ? (
          <Check fontSize="small" color="success" />
        ) : (
          <ContentCopy
            fontSize="small"
            color="primary"
            sx={{
              transition: "transform 0.2s ease",
              transform: isHovered ? "scale(1.1)" : "none",
            }}
          />
        )
      }
      label={
        <Box
          sx={{
            minWidth,
            maxWidth: 100, // 🔑 overflow kontrol
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {labelText}
        </Box>
      }
      sx={{
        borderRadius: "999px",
        fontWeight: 500,
        px: size === "small" ? 0.5 : 1,

        transition: "all 0.2s ease",
        backgroundColor,
        color,

        "&:hover": {
          backgroundColor: alpha(theme.palette.primary.main, 0.2),
        },
      }}
    />
  );
};
